module.exports = __webpack_public_path__ + "fonts/1a7c9181-cd24-4943-a9d9-d033189524e0.13be2b0.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/1a7c9181-cd24-4943-a9d9-d033189524e0.eot
// module id = 84
// module chunks = 245 246